import React, { HTMLAttributes } from 'react'
import { classList } from 'services/styles'
import { useStyles } from './styles'

export interface IButtonStackProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  fullWidth?: boolean
  variant?: 'default' | 'compact'
}

function ButtonStack(props: IButtonStackProps) {
  const { children, fullWidth, variant = 'compact', className, ...restProps } = props
  const { classes } = useStyles()

  return (
    <div className={classList(classes.container, fullWidth ? classes.fullwidth : undefined, classes[variant], className)} {...restProps}>
      {children}
    </div>
  )
}

export default React.memo(ButtonStack)
